import React from "react";
import { OutlinedInput, InputAdornment, IconButton } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import { useTheme } from "@mui/material/styles";

export default function SearchBar({ value, onChange, onSearch, placeholder }) {
    const theme = useTheme();

    const handleKeyPress = (event) => {
        if (event.key === "Enter") {
            onSearch(); // Trigger the onSearch function when "Enter" is pressed
        }
    };

    return (
        <OutlinedInput
            type="search"
            sx={{ borderRadius: "20px", width: "100%" }}
            value={value}
            onChange={onChange}
            onKeyPress={handleKeyPress}
            placeholder={placeholder}
            aria-label="Search"
            endAdornment={
                <InputAdornment position="end" sx={{ paddingRight: "0.55em" }}>
                    <IconButton
                        onClick={onSearch}
                        edge="end"
                        sx={{
                            "color": theme.palette.grey[50],
                            "backgroundColor": theme.palette.primary.dark,
                            "&:hover": {
                                "color": theme.palette.grey[50],
                                "backgroundColor": theme.palette.primary[800],
                            },
                        }}
                    >
                        <SearchIcon />
                    </IconButton>
                </InputAdornment>
            }
        />
    );
}
